<template>
	<div
		class="form-floating mb-3 password-input"
		:class="{ 'transparent-form-floating': transparent }">
		<input
			:type="show ? 'text' : 'password'"
			class="form-control"
			:class="{
				'transparent-form-control': transparent,
			}"
			:id="inputId"
			:placeholder="label"
			:value="modelValue"
			@input="$emit('update:modelValue', $event.target.value)" />
		<label class="form-label" :for="inputId">{{ label }}</label>
		<button
			class="btn btn-outline-secondary password-toggle"
			type="button"
			@click="toggleShow"
			tabindex="-1">
			<i :class="show ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
		</button>
	</div>
</template>

<script setup>
	import { ref, computed } from "vue"

	const props = defineProps({
		modelValue: String,
		label: {
			type: String,
			default: "Password",
		},
		transparent: {
			type: Boolean,
			default: false,
		},
	})
	const emit = defineEmits(["update:modelValue"])
	const show = ref(false)

	// Generate a unique id for the input for accessibility
	const inputId = computed(
		() => `password-input-${Math.random().toString(36).substr(2, 9)}`
	)

	function toggleShow() {
		show.value = !show.value
	}
</script>

<style scoped>
	.password-input {
		position: relative;
	}
	input.form-control {
		padding-right: 2.5rem;
	}
	.password-toggle {
		position: absolute;
		right: 0.5rem;
		top: 50%;
		transform: translateY(-50%);
		z-index: 2;
		border: none;
		background: none;
		color: #888;
		padding: 0 0.5rem;
		height: 2rem;
		display: flex;
		align-items: center;
	}
	.password-toggle:focus {
		box-shadow: none;
	}

	/* Transparent inputs for this view */
	.transparent-form-control {
		background-color: transparent !important;
		color: #ffffff !important;
		border-color: rgba(255, 255, 255, 0.25);
	}
	.transparent-form-control:focus {
		background-color: transparent !important;
		color: #ffffff !important;
		box-shadow: 0 0 0 0.2rem rgba(34, 197, 94, 0.25);
		border-color: #22c55e;
	}
	.transparent-form-floating > label {
		background-color: transparent !important;
		color: #cbd5e1;
	}
	.transparent-form-control::placeholder {
		color: #94a3b8;
		opacity: 0.8;
	}

	.transparent-form-floating .password-toggle {
		color: #ffffff !important;
	}
</style>
